import type { TOCContent } from "contexts/Interface/CMSManagment/CMSManagmentInterface";

/**
 * CMS /toc API returns localized copy under `data[]` (text, title, language.lang_code).
 * Legacy UI expects flat title_en / content_en / … on tocContent.
 */
export function normalizeTocApiRow(row: unknown): TOCContent {
  if (!row || typeof row !== "object") {
    return row as TOCContent;
  }

  const r = row as Record<string, unknown>;
  const data = r.data;

  const merged: Record<string, unknown> = { ...r };

  if (Array.isArray(data)) {
    merged.data = data;
    for (const item of data as Array<{
      text?: string;
      title?: string;
      language?: { lang_code?: string };
    }>) {
      const code = item?.language?.lang_code?.toLowerCase();
      if (!code) continue;
      merged[`title_${code}`] = item.title ?? "";
      merged[`content_${code}`] = item.text ?? "";
    }
  }

  return merged as unknown as TOCContent;
}
